/* 
* { replaceData } 脱敏处理 参数1 需要脱敏的数据  参数2 需要脱敏的类型
* { desensitizationDispose } 考虑列表及表单过滤脱敏数据
*/

import store from '@/store/index.js';
import _ from 'lodash';
import website from '@/config/website';
export const replaceData = (targetVal, type) => {
  switch (type) {
    // 身份证类型
    case 'idCard':
      if (targetVal && targetVal.length == 18)
        targetVal = targetVal.replace(/(\d{3})\d*(\d{3})/, '$1************$2')
      break;
    // 名字类型
    case 'name':
      if (!targetVal) return targetVal
      if (targetVal && targetVal.length && targetVal.length == 2) {
        targetVal = targetVal.substring(0, 1) + '*' //截取name 字符串截取第一个字符，
      } else if (targetVal && targetVal.length && targetVal.length == 3)
        targetVal = targetVal.substring(0, 1) + '*' + targetVal.substring(2, 3)
      else if (targetVal.length > 3) {
        let str = ''
        for (let i = 0; i < targetVal.length - 2; i++) {
          str += '*'
        }
        targetVal = targetVal.substring(0, 1) + str + targetVal.substring(targetVal.length - 1, targetVal.length)
      }
      break;
    // 手机号类型
    case 'phone':
      if (targetVal && targetVal.length == 11)
        targetVal = targetVal.replace(/(\d{3})\d*(\d{4})/, '$1****$2')
      break;
    default:
      false
  }
  return targetVal
}


/* 
* ProviderData 需要脱敏的数据源需要是Array或者Object. 
* SpecialList  已经配置脱敏但在局部业务中不需要脱敏的数据 
               支持 1.数组（多字段或单字段）  2.布尔值false（全部不需要脱敏）。
*/
export const desensitizationDispose = (ProviderData, type, SpecialList = []) => {

  if (!website.openDictionar) return ProviderData  // 全局不脱敏时忽略逻辑
  if (!SpecialList || (type && type !== 'view' && type !== 'list')) return ProviderData  // 剔除  1.SpecialList为布尔值的情况   2.非详情  3.列表

  const desensitizeList = _.cloneDeep(store.state.common.desensitization) // 需脱敏数据源


  // 清洗特殊不脱敏字段
  if (Object.prototype.toString.call(SpecialList) === '[object Array]') {
    if (SpecialList.length) {
      for (const key in desensitizeList) {
        desensitizeList[key].length && desensitizeList[key].forEach((item, index) => {
          if (SpecialList.find((finditem) => finditem === item)) desensitizeList[key].splice(index, 1)
        })
      }
    }
  }

  if (ProviderData && Object.prototype.toString.call(ProviderData) === '[object Object]') {
    for (const key in desensitizeList) {
      for (let Providekey in ProviderData) {
        if (desensitizeList[key].length && desensitizeList[key].find((item) => Providekey === item)) {
          ProviderData[Providekey] = replaceData(ProviderData[Providekey], key)
        }
      }
    }
  }
  else if (ProviderData && Object.prototype.toString.call(ProviderData) === '[object Array]') {
    for (const key in desensitizeList) {
      ProviderData.forEach(item => {
        for (let itemkey in item) {
          if (desensitizeList[key].length && desensitizeList[key].find((item) => itemkey === item)) {
            item[itemkey] = replaceData(item[itemkey], key)
          }
        }
      });
    }
  }
  return ProviderData
}



